import angular from 'angular';
import ordersComponent from './orders.component';
import OrdersService from './orders.service';
import ordersConfig from './orders.config';
import SyncOrderModalController from './sync-order-modal/sync-order-modal.controller';
import ModalDriversOrderRegisterController from './modal-drivers-register/modal-drivers-order-register.controller';
import orderDetailModule from './order-detail/order-detail';

import trackingModule from './tracking/tracking'

let ordersModule = angular.module('app.orders',[orderDetailModule.name,trackingModule.name])
  .component('orders', ordersComponent)
  .controller('SyncOrderModalController', SyncOrderModalController)
  .controller('ModalDriversOrderRegisterController', ModalDriversOrderRegisterController)
  .service('OrdersService', OrdersService)
  .config(ordersConfig);

export default ordersModule;



/** WEBPACK FOOTER **
 ** ./www/components/orders/orders.js
 **/